<template>
  <p
    v-if="text"
    :id="id"
    class="cat-hint-text"
    data-label-type="hint"
    v-html="text"
  ></p>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CatHint",
  props: {
    text: {
      type: [String]
    },
    id: {
      type: [String]
    }
  }
});
</script>
